import { UserProfile } from "@/lib/types";

interface WelcomeHeaderProps {
  profile: UserProfile | null;
}

const WelcomeHeader = ({ profile }: WelcomeHeaderProps) => {
  return (
    <div className="text-left">
      <h1 className="text-2xl font-bold text-foreground">
        Welcome{profile?.first_name && profile?.last_name ? `, ${profile.first_name} ${profile.last_name}` : ""}!
      </h1>
      <p className="text-muted-foreground">
        Here's what's happening with your estimates today.
      </p>
    </div>
  );
};

export default WelcomeHeader;
